<template>
  <div class="card-box" v-if="cartData[4].value" :style="{ top: cartData[4].top, height: cartData[4].height }">
    <div class="tabs" v-drag>
      <div :class="{ tab: true, active: forecastType === item }" v-for="item in cartData[4].types" :key="item">
        <div class="name" @click="changeForecast(item)" @mousedown.stop="() => { }">
          {{ mapCardName(item) }}
        </div>
      </div>
    </div>
    <div class="card-close" @click="changeCartShow(4)">
      <img src="../assets/images/关闭.png" />
    </div>
    <transition-group name="el-zoom-in-top">
      <tqsk :key="forecastType" v-if="forecastType === 19"></tqsk>
      <risk :key="forecastType" v-else-if="[28].includes(forecastType)" :forecastType="forecastType"></risk>
      <three-risk :key="forecastType" v-else-if="[20].includes(forecastType)" :forecastType="forecastType"></three-risk>
      <forest :key="forecastType" v-else-if="[9].includes(forecastType)" :forecastType="forecastType"></forest>
      <three-forest :key="forecastType" v-else-if="[29].includes(forecastType)"
        :forecastType="forecastType"></three-forest>
      <SevenForest :key="forecastType" v-else-if="[67].includes(forecastType)" :forecastType="forecastType">
      </SevenForest>
      <!--      <town-warn :key="forecastType" v-else-if="[37].includes(forecastType)" :forecastType="forecastType"></town-warn>-->
      <warn :key="forecastType" v-else-if="[37].includes(forecastType)" :forecastType="forecastType"></warn>
      <rain-live :key="forecastType" v-else-if="[43].includes(forecastType)" :forecastType="forecastType"></rain-live>
      <live-forest :key="forecastType" v-else-if="[36].includes(forecastType)"
        :forecastType="forecastType"></live-forest>
      <rain-image :key="forecastType" v-else-if="[44].includes(forecastType)" :forecastType="forecastType"></rain-image>
      <icy-road :key="forecastType" v-else-if="[40].includes(forecastType)"></icy-road>
      <obt-live :key="forecastType" v-else-if="forecastType === 49"></obt-live>
      <index-number :key="forecastType" v-else-if="forecastType === 52"></index-number>
      <ultraviolet-rays :key="forecastType" ultravioletRaysChartId="ultraviolet-rays-chart-c"
        v-else-if="forecastType === 54"></ultraviolet-rays>
      <instant-risk :key="forecastType" v-else-if="forecastType === 56"></instant-risk>
      <multi-weather :key="forecastType" v-else-if="forecastType === 57"></multi-weather>
      <water-temperature-live :key="forecastType" v-else-if="forecastType === 58"></water-temperature-live>
      <water-temperature-station :key="forecastType" v-else-if="forecastType === 60"></water-temperature-station>
      <town-warn :key="forecastType" v-else-if="61 === forecastType"></town-warn>
      <risk-waterlogging :key="forecastType" v-else-if="forecastType === 38"></risk-waterlogging>
      <air-quality :key="forecastType" v-else-if="forecastType === 65"></air-quality>
      <refined-rainfall :key="forecastType" v-else-if="forecastType === 64"></refined-rainfall>
      <county-occupant :key="forecastType" v-else-if="forecastType === 66"></county-occupant>
      <undeveloped :key="-1" v-else></undeveloped>
    </transition-group>
    <div class="line"></div>
    <div class="line line1"></div>
  </div>
</template>

<script>
import Tqsk from "@/components/module/card/wqsk.vue";
import Risk from "@/components/module/card/risk.vue";
import ThreeRisk from "@/components/module/card/three-risk.vue";
import Forest from "@/components/module/card/hour-forest";
import ThreeForest from "@/components/module/card/three-forest.vue";
import SevenForest from "@/components/module/card/seven-forest.vue";
import RainLive from "@/components/module/card/rain-live.vue";
import LiveForest from "@/components/module/card/live-forest.vue";
import Warn from "@/components/module/card/warn.vue";
import RainImage from "@/components/module/card/rain-image.vue";
import Undeveloped from "@/components/module/card/undeveloped.vue";
import IcyRoad from "@/components/module/card/icy-road.vue";
import ObtLive from "@/components/module/card/obt-live.vue";
import { mapMutations, mapState } from "vuex";
import IndexNumber from "@/components/module/card/index-number.vue";
import UltravioletRays from "@/components/module/card/ultraviolet-rays.vue";
import InstantRisk from "@/components/module/card/instant-risk.vue";
import MultiWeather from "@/components/module/card/multi-weather.vue";
import WaterTemperatureLive from "@/components/module/card/water-temperature-live.vue";
import WaterTemperatureStation from "@/components/module/card/water-temperature-station.vue";
import TownWarn from "@/components/module/card/town-warn.vue";
import riskWaterlogging from "@/components/module/card/risk-waterlogging.vue";
import airQuality from "@/components/module/card/air-quality.vue";
import countyOccupant from "@/components/module/card/county-occupant.vue";
import refinedRainfall from "@/components/module/card/refined-rainfall.vue";
export default {
  components: {
    TownWarn,
    WaterTemperatureStation,
    WaterTemperatureLive,
    MultiWeather,
    InstantRisk,
    UltravioletRays,
    IndexNumber,
    Tqsk,
    Risk,
    ThreeRisk,
    Forest,
    ThreeForest,
    SevenForest,
    LiveForest,
    RainLive,
    Warn,
    RainImage,
    Undeveloped,
    IcyRoad,
    ObtLive,
    riskWaterlogging,
    airQuality,
    countyOccupant,
    refinedRainfall,
  },
  props: ["params"],
  data() {
    return {
      charts: [],
      forecastType: null,
      giftData: {},
      timmer: null,
    };
  },
  watch: {
    cartData: {
      handler() {
        if (this.cartData[4].types.length > 0) {
          this.changeForecast(this.cartData[4].types[0]);
        }
      },
      deep: true,
    },
  },
  mounted() {
    this.forecastType = this.cartData[4].types[0];
    this.changeHeight();
  },
  computed: {
    ...mapState("home", ["cartData", "cardOptions"]),
    mapCardName() {
      return function (id) {
        const item = this.cardOptions.find((item) => item.id === id);
        return item ? item.name : "";
      };
    },
  },
  methods: {
    ...mapMutations("home", ["changeCartShow", "changeCartHeight"]),
    changeForecast(name) {
      this.forecastType = name;
    },
    changeHeight() {
      if (this.forecastType === 57) {
        this.changeCartHeight({
          index: 4,
          height: "auto",
        });
      } else {
        this.changeCartHeight({
          index: 4,
          height: "23.5vh",
        });
      }
    },
  },
};
</script>

<style lang="less" scoped>
.card-box {
  right: 1.09vw;
  top: 42vh;
}
</style>
